import Pristine from 'pristinejs';
import { load } from 'recaptcha-v3';

import '../sass/citrus-contact.scss';

(() => {
    const $citrusContacts = document.querySelectorAll('.citrus-contact');

    if (!$citrusContacts) return;

    const { RECAPTCHA_V3_SITE_KEY } = GLOBALS;

    $citrusContacts.forEach($citrusContact => {
        const $form = $citrusContact.querySelector('.citrus-contact__form');

        const initFormValidation = () => {
            if (!$form) return;

            const pristine = new Pristine($form);
        
            $form.addEventListener('submit', e => {
                e.preventDefault();

                if ($form.classList.contains('citrus-contact__form--loading')) {
                    return;
                }

                $form.classList.add('citrus-contact__form--loading');

                if (!pristine.validate()) {
                    $form.classList.remove('citrus-contact__form--loading');

                    return;
                }

                const $recaptchaTokenInput = $form.querySelector('.recaptcha-token');

                if (RECAPTCHA_V3_SITE_KEY && $recaptchaTokenInput) {
                    load(RECAPTCHA_V3_SITE_KEY).then((recaptcha) => {
                        recaptcha.execute('contact').then((token) => {
                            $recaptchaTokenInput.value = token;

                            $form.submit();
                        });
                    });
                } else {
                    $form.submit();
                }
            });
        };

        initFormValidation();
    });
})();
